/**
 * True when the listing's top category is desktop or laptop (Masaüstü / Dizüstü).
 * Used to gate AI performance testing on listing detail pages.
 */
export function isDesktopOrLaptopTopCategory(
  topCategoryName?: string | null,
  topCategoryId?: number | null
): boolean {
  if (topCategoryId === 1 || topCategoryId === 2) return true;
  if (!topCategoryName) return false;
  const normalized = topCategoryName.toLocaleLowerCase('tr-TR');
  return (
    normalized.includes('masaüstü') ||
    normalized.includes('masaustu') ||
    normalized.includes('dizüstü') ||
    normalized.includes('dizustu') ||
    normalized.includes('desktop') ||
    normalized.includes('laptop')
  );
}
